import { css } from "@emotion/react";

export const icon = css`
  margin-left: 0.5rem;
`;

export const rotatedIcon = css`
  transform: rotate(180deg);
`;
